//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
import styles from './style.module.scss';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import { ReactComponent as QuotesIcon } from '../../assets/images/quotes.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import { getFullMonthName } from 'src/onboarding/helpers/getFullMonthName';
import { useRemoteConfig } from '@web-solutions/base-app/hooks/use-remote-config';
import { getAdjustedDate } from 'src/onboarding/helpers/getAdjustedDate';
import { getEarlyAchievableOffset } from 'src/onboarding/helpers/getEarlyAchievableOffset';

function Page() {
  const weight = useStore((state) => state.weight);
  const height = useStore((state) => state.height);
  const idealWeight = useStore((state) => state.idealWeight);
  const when = useStore((state) => state.when);
  const setTrialPrice = useStore((state) => state.setTrialPrice);

  const { routeGroups: flow, products } = useRemoteConfig();

  const adjustedDate = getAdjustedDate(when, getEarlyAchievableOffset(when));

  const isShowNewDate = getEarlyAchievableOffset(when) !== null && flow.flat().includes('goal-2');

  const renderDate = isShowNewDate ? adjustedDate : when;
  const formattedDate = `${t(`onboarding.common.calendar.${getFullMonthName(renderDate.month)}`)}, ${renderDate.day}`;

  const { onNext, onPrev, currentIndex } = useNav();

  const handlePriceClick = (price: string) => {
    setTrialPrice(price);
    onNext();
  };

  const renderInfoBlock = (emoji: string, title: string, value: string | number) => (
    <div className={styles.infoBlock}>
      <span>{emoji}</span>
      <div className={styles.infoContent}>
        <Caption className={styles.infoTitle}>{title}</Caption>
        <Text size='s' semibold className={styles.infoValue}>
          {value}
        </Text>
      </div>
    </div>
  );

  return (
    <div className={'page'}>
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.trialPrice.title')}</Title>
        <div className={styles.parametersInfo}>
          {renderInfoBlock(
            '⚖️',
            t('onboarding.trialPrice.todayWeight'),
            weight.type === 'lbs' ? `${weight.lbs} lbs` : `${weight.kg} kg`
          )}
          {renderInfoBlock(
            '📏',
            t('onboarding.trialPrice.height'),
            height.type === 'cm' ? `${height.cm} cm` : `${height.ft} ft`
          )}
          {renderInfoBlock(
            '🎯',
            t('onboarding.trialPrice.targetWeight'),
            `${idealWeight.value} ${idealWeight.type}`
          )}
          {renderInfoBlock('⏳️', t('onboarding.trialPrice.goalDate'), formattedDate)}
        </div>
        <div className={'message'}>
          <Text size='m' medium>
            {t('onboarding.trialPrice.statement')} 🎯
          </Text>
        </div>
        <div className={styles.prices}>
          {products.map((product, index) => (
            <div
              className={styles.price}
              key={index}
              onClick={() => handlePriceClick(product.subTitle.en)}
            >
              {index === 2 && product.highlightDescription?.en && (
                <Caption size='s' className={styles.highlight}>
                  {product.highlightDescription.en}
                </Caption>
              )}
              <Text semibold>{product.subTitle.en}</Text>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
export default Page;
